/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AllInputs */

const en_all = /** @type {(inputs: AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const fr_all = /** @type {(inputs: AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous`)
};

const de_all = /** @type {(inputs: AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const it_all = /** @type {(inputs: AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto`)
};

const ru_all = /** @type {(inputs: AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все`)
};

const es_all = /** @type {(inputs: AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo`)
};

const zh_cn2_all = /** @type {(inputs: AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const ja_all = /** @type {(inputs: AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全て`)
};

const hi_all = /** @type {(inputs: AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी`)
};

const pt_pt2_all = /** @type {(inputs: AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const all = /** @type {((inputs?: AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_all(inputs)
	if (locale === "de") return de_all(inputs)
	if (locale === "it") return it_all(inputs)
	if (locale === "ru") return ru_all(inputs)
	if (locale === "es") return es_all(inputs)
	if (locale === "zh-CN") return zh_cn2_all(inputs)
	if (locale === "ja") return ja_all(inputs)
	if (locale === "hi") return hi_all(inputs)
	if (locale === "pt-PT") return pt_pt2_all(inputs)
	return en_all(inputs)
});